var angular = require('angular');
var _module = require('../../module');
var _ = require('lodash');

require('../../../services/new-filter-modal');
require('../../../services/edit-filter-modal');
require('../../../services/delete-filter-modal');
require('../../../services/analytics');
require('../../../services/fullscreen-loading');

_module.component('searchControls', {
    bindings: {
        isMobile: '<',
        currentView: '<',
        switchCurrentView: '&',
        sortListBy: '<',
        sortListByUpdated: '&',
        searchSubmit: '&',
        updateFilterData: '&',
        updateCurrentFilter: '&',
        usr: '=userData',
        ui: '=uiFeedback'
    },
    controllerAs: 'searchCtrl',
    controller: [
        '$log',
        '$scope',
        '$timeout',
        '$stateParams',
        '$newFilterModal',
        '$editFilterModal',
        '$deleteFilterModal',
        'srUtils',
        '$analytics',
        '$filter',
        '$window',
        'localStorageService',
        '$fsloading',

        function searchControlsCtrl($log, $scope, $timeout, $stateParams, $newFilterModal, $editFilterModal, $deleteFilterModal, srUtils, $analytics, $filter, $window, localStorageService, $fsloading) {
            var _this = this;

            var initLayout = function () {
                _this.layout = {
                    showDropdown:{},
                    showDropup:{
                        sort: false,
                        myFilters: false
                    },
                    currentView: _this.currentView,
                    windowHeight: $window.innerHeight
                };
            };

            var trackFilterUpdateEvent = function (obj, operation) {
                var op = $filter('capitalize')(operation);
                var eventName = [op, 'Filter Button Click'].join(' ');
                var eventData = {
                    'Filter ID': obj.id,
                    'Filter Name': obj.name
                };

                $analytics.eventTrack(eventName, eventData);
            };

            var onFilterUpdate = function (obj, operation) {
                if(obj){
                    $timeout(function onFilterUpdateTO() {
                        var payload = {$operation: operation};
                        if(!!obj.id) payload.$filterId = obj.id;
                        if(!!obj.search_term) payload.$keyword = obj.search_term;
                        if(!!obj.name) payload.$name = obj.name;
                        if(!!obj.params) payload.$params = obj.params;

                        _this.updateFilterData(payload);
                        trackFilterUpdateEvent(obj, operation);
                        _this.closeControlsOverlay();
                        _this.closeFilterOverlay();
                    }, 100);
                }
            };

            var onNewFilterCreate = function (obj) {
                if(obj){
                    $editFilterModal(null, 'new', obj.keyword, obj.latLng)
                        .then(function (response) {
                            onFilterUpdate(response, 'new');
                        });
                }
            };

            _this.filterOperation = function (filterData, operation) {
                if(filterData && filterData.id){
                    _this.layout.showDropdown[filterData.id] = false;
                }

                var data = JSON.parse(JSON.stringify(filterData || {}));
                switch (operation) {
                    case 'new':
                        $newFilterModal()
                            .then(function (response) {
                                if(response) {
                                    onNewFilterCreate(response);
                                }else {
                                    $log.debug('No response from newFilterModal', response);
                                }
                            })
                            .catch(function (err) {
                                $log.error('Error trying to create new filter!', err);
                            });
                        break;

                    case 'edit':
                        $editFilterModal(data, operation)
                            .then(function (response) {
                                onFilterUpdate(response, 'edit');
                            });
                        break;

                    case 'duplicate':
                        $editFilterModal(data, operation)
                            .then(function (response) {
                                onFilterUpdate(response, 'duplicate');
                            });
                        break;

                    case 'delete':
                        $deleteFilterModal(data, operation)
                            .then(function (response) {
                                if(response) {
                                    onFilterUpdate(response, 'delete');
                                }
                            });
                        break;

                    default: break;
                }
            };

            _this.switchToCurrentFilter = function (id) {
                if(id){
                    $fsloading.show();
                    _this.keyword = '';
                    _this.layout.showDropdown[id] = false;

                    $timeout(function () {
                        _this.updateCurrentFilter({$filterid: id});
                        _this.closeControlsOverlay();
                        _this.closeFilterOverlay();
                        $fsloading.hide();
                    });
                }
            };

            _this.switchView = function () {
                var viewName = (_this.layout.currentView == 'map')
                                    ? 'list'
                                    : 'map';

                _this.layout.currentView = viewName;
                $timeout(function () {
                    _this.switchCurrentView({$viewName: viewName});
                }, 10);
            };

            _this.editFilterName = function (sfilter, editedName) {
                onFilterUpdate({
                    name: editedName,
                    id: sfilter.id,
                    params: sfilter.params,
                    search_term: sfilter.search_term
                }, 'editname');

                _this.displayFilter.name = editedName;
                _this.ui.filterNameEditToggle = false;
            };

            _this.toggleDisplayFilterOverlay = function (filterId) {
                if(_this.ui && _this.ui.resultSource === 'search') {
                    _this.keyword = '';
                    _this.switchToCurrentFilter(filterId);
                }else{
                    if(!_this.layout.showFilterOverlay) {
                        _this.displayFilterOverlay(filterId);
                    }else{
                        _this.closeFilterOverlay();
                    }
                }
            };

            _this.displayFilterOverlay = function (filterId) {
                var displayFilter = {};
                if(!filterId){
                    displayFilter = JSON.parse(JSON.stringify(_this.usr.currentFilter));
                }else{
                    _this.layout.showDropdown[filterId] = false;
                    displayFilter = JSON.parse(JSON.stringify(_.find(_this.usr.filters, {'id': filterId})));
                }

                if(displayFilter.params){
                    displayFilter.humanizedParams = srUtils.humanizeFilterParams(displayFilter.params);
                }
                _this.displayFilter = displayFilter;
                _this.layout.showFilterOverlay = true;
            };

            _this.closeFilterOverlay = function () {
                _this.layout.showFilterOverlay = false;
            };

            var closeRemainingControlsOverlays = function (section) {
                if(section && _this.layout.showDropup) {
                    angular.forEach(_this.layout.showDropup, function (val, key) {
                        if(key !== section) {
                            this[key] = false;
                        }
                    }, _this.layout.showDropup);
                }
            };

            _this.toggleControlsOverlay = function (section) {
                closeRemainingControlsOverlays(section);
                if(_this.layout && _this.layout.showDropup && _this.layout.showDropup.hasOwnProperty(section)){
                    _this.layout.showDropup[section] = !_this.layout.showDropup[section];
                }
            };

            _this.closeControlsOverlay = function () {
                _this.layout.showDropup['sort'] = false;
                _this.layout.showDropup['myFilters'] = false;
            };

            _this.sortListByChanged = function (title) {
                if(title){
                    $timeout(function () {
                        _this.sortListByUpdated({$title: title});
                        _this.layout.showDropup['sort'] = false;
                    }, 10);
                }
            };

            this.onSubmit = function onFormSubmit() {
                if(_this.keyword) {
                    $timeout(function onFormSubmitTO() {
                        _this.searchSubmit({ $keyword: _this.keyword, $latLng: _this.latLng, $noPageReset: false });
                    }, 200);

                    $analytics.eventTrack('Listing Search Submit', {
                        Source: 'Results Page',
                        'Search Term': _this.keyword
                    });
                }
            };

            var initSearchParamCheck = function () {
                if($stateParams && $stateParams.q && $stateParams.q.length > 0) {
                    _this.keyword = $stateParams.q;
                }else if(localStorageService.get('userCurrentState')) {
                    var userCurrentState = localStorageService.get('userCurrentState');
                    if(userCurrentState.keyword && userCurrentState.resultSource == 'search') {
                        _this.keyword = userCurrentState.keyword;
                    }
                }
            };

            var init = function () {
                initLayout();
                initSearchParamCheck();
            };

            init();


            _this.shouldShowSortByDomOption = function (opt) {
                return ((opt.title === 'Sort by Days on Market' && (_this.ui && _this.ui.showSortByDomOption)) ||
                    opt.title !== 'Sort by Days on Market');
            };


            ///////////////////////
            //      WATCHERS     //
            ///////////////////////


            /*if(_this.usr && _this.usr.currentFilter) {
                $scope.$watch(function (scope) {
                    return _this.usr.currentFilter;
                }, function (newVal, oldVal) {
                    if(newVal && !!newVal.id && newVal !== oldVal) {
                        _this.displayFilterOverlay(newVal.id);
                    }
                }, true);
            }*/
        }
    ],
    template: require('./index.html')
});
